import {
  Inconsistency5SFilesActionTypes,
  InconsistencyFile,
  FetchFilesRequestAction,
  FetchFilesSuccessAction,
  FetchFilesFailureAction,
  UploadFileRequestAction,
  UploadFileSuccessAction,
  UploadFileFailureAction,
  DeleteFileRequestAction,
  DeleteFileSuccessAction,
  DeleteFileFailureAction,
} from '../../types/inconsistency5SFiles';

export const fetchInconsistencyFiles = (
  inconsistencyId: number,
  inconsistencyDocumentId: string,
): FetchFilesRequestAction => ({
  type: Inconsistency5SFilesActionTypes.FETCH_REQUEST,
  payload: { inconsistencyId, inconsistencyDocumentId },
});

export const fetchInconsistencyFilesSuccess = (
  inconsistencyId: number,
  files: InconsistencyFile[],
): FetchFilesSuccessAction => ({
  type: Inconsistency5SFilesActionTypes.FETCH_SUCCESS,
  payload: { inconsistencyId, files },
});

export const fetchInconsistencyFilesFailure = (
  inconsistencyId: number,
  error: string,
): FetchFilesFailureAction => ({
  type: Inconsistency5SFilesActionTypes.FETCH_FAILURE,
  payload: { inconsistencyId, error },
});

export const uploadInconsistencyFile = (
  inconsistencyId: number,
  file: File,
  tempId: string,
): UploadFileRequestAction => ({
  type: Inconsistency5SFilesActionTypes.UPLOAD_REQUEST,
  payload: { inconsistencyId, file, tempId },
});

export const uploadInconsistencyFileSuccess = (
  inconsistencyId: number,
  tempId: string,
  file: InconsistencyFile,
): UploadFileSuccessAction => ({
  type: Inconsistency5SFilesActionTypes.UPLOAD_SUCCESS,
  payload: { inconsistencyId, tempId, file },
});

export const uploadInconsistencyFileFailure = (
  inconsistencyId: number,
  tempId: string,
  error: string,
): UploadFileFailureAction => ({
  type: Inconsistency5SFilesActionTypes.UPLOAD_FAILURE,
  payload: { inconsistencyId, tempId, error },
});

export const deleteInconsistencyFile = (
  inconsistencyId: number,
  recordDocumentId: string,
  fileId?: number,
): DeleteFileRequestAction => ({
  type: Inconsistency5SFilesActionTypes.DELETE_REQUEST,
  payload: { inconsistencyId, recordDocumentId, fileId },
});

export const deleteInconsistencyFileSuccess = (
  inconsistencyId: number,
  recordDocumentId: string,
): DeleteFileSuccessAction => ({
  type: Inconsistency5SFilesActionTypes.DELETE_SUCCESS,
  payload: { inconsistencyId, recordDocumentId },
});

export const deleteInconsistencyFileFailure = (
  inconsistencyId: number,
  recordDocumentId: string,
  error: string,
): DeleteFileFailureAction => ({
  type: Inconsistency5SFilesActionTypes.DELETE_FAILURE,
  payload: { inconsistencyId, recordDocumentId, error },
});
